import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useRedirectToLogin } from './useRedirectToLogin';

export function useCheckAuth() {
  const redirectToLogin = useRedirectToLogin();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      redirectToLogin();
    }
  }, [pathname, redirectToLogin]);
}
